// extracted by mini-css-extract-plugin
export default {"actions":"DataTable_actions__M3qjW","data-table":"DataTable_data-table__bW9Pq"};